/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIAuthor
 */
export interface APIAuthor {
    /**
     * 
     * @type {string}
     * @memberof APIAuthor
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIAuthor
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAuthor
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAuthor
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAuthor
     */
    lastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIAuthor
     */
    isGuestUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAuthor
     */
    isOrgAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIAuthor
     */
    isStaff?: boolean;
}

/**
 * Check if a given object implements the APIAuthor interface.
 */
export function instanceOfAPIAuthor(value: object): value is APIAuthor {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIAuthorFromJSON(json: any): APIAuthor {
    return APIAuthorFromJSONTyped(json, false);
}

export function APIAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAuthor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'isGuestUser': json['is_guest_user'] == null ? undefined : json['is_guest_user'],
        'isOrgAdmin': json['is_org_admin'] == null ? undefined : json['is_org_admin'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
    };
}

export function APIAuthorToJSON(value?: APIAuthor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'full_name': value['fullName'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'is_guest_user': value['isGuestUser'],
        'is_org_admin': value['isOrgAdmin'],
        'is_staff': value['isStaff'],
    };
}

